import type { AurricaFeatureFlags } from '../config/aurrica-app-config.types';

/** `/s`, `/s/<token>`, `/s?…`, `/s#…`; never `/share-links` or `/settings`. */
const PUBLIC_SHARE_PATH = /^\/s(?:[/?#]|$)/;

/**
 * Whether `url` (a path or router URL, e.g. `/s/abc?lang=fr`) is the public live-share page,
 * which anyone holding the link opens without logging in.
 */
export function isPublicSharePath(url: string): boolean {
  return PUBLIC_SHARE_PATH.test(url);
}

/**
 * Whether this page load starts on the public live-share page while the feature is on.
 *
 * Startup code checks this to leave a stored session alone: a viewer who happens to be
 * logged in (an issuer testing their own link, a carrier who received one) must not be
 * refreshed, prompted for notifications, sent to a deep link or redirected to `/login`.
 */
export function isPublicShareEntry(
  path: string,
  features: AurricaFeatureFlags,
): boolean {
  return features.liveShareLinks && isPublicSharePath(path);
}
